import NoTests from "pages/LandingPages/NoTests/noTests";

export default function NoTestsPage() {
  return <NoTests />;
}